import { render, staticRenderFns } from "./PolyIntegerReferenceCard.vue?vue&type=template&id=657f4827&"
import script from "./PolyIntegerReferenceCard.vue?vue&type=script&lang=js&"
export * from "./PolyIntegerReferenceCard.vue?vue&type=script&lang=js&"
import style0 from "./PolyIntegerReferenceCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports